module.exports = __webpack_public_path__ + "static/media/logo_asus.a7e80960.png";